import clsx from 'clsx';
import { FC } from 'react';

export type CheckboxProps = {
    isChecked: boolean;
    setIsChecked: (value: boolean) => void;
    disabled?: boolean;
    id?: string;
    name?: string;
    ariaLabel?: string;
    className?: string;
};

const Checkbox: FC<CheckboxProps> = ({ isChecked, setIsChecked, disabled, id, name, ariaLabel, className }) => {
    return (
        <label
            className={clsx(
                'relative flex h-5 w-5 items-center justify-center',
                disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                className,
            )}
        >
            <input
                id={id}
                name={name}
                type="checkbox"
                className="peer absolute inset-0 m-0 h-full w-full opacity-0 pointer-events-none"
                checked={isChecked}
                disabled={disabled}
                aria-label={ariaLabel}
                data-state={isChecked ? 'checked' : 'unchecked'}
                onClick={(event) => {
                    event.stopPropagation();
                }}
                onChange={(event) => {
                    event.stopPropagation();
                    setIsChecked(event.target.checked);
                }}
            />
            <div
                aria-hidden="true"
                className={clsx(
                    'flex h-5 w-5 items-center justify-center rounded-md border transition-all duration-200 peer-focus-visible:outline-2 peer-focus-visible:outline-blue-500 peer-focus-visible:outline-offset-2',
                    isChecked ? 'border-blue-500 bg-blue-500' : 'border-[#e0e0e0] bg-white',
                    disabled && 'grayscale-90',
                    disabled && !isChecked && 'bg-gray-200',
                )}
                data-state={isChecked ? 'checked' : 'unchecked'}
            >
                {isChecked && (
                    <svg className="h-3.5 w-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                    </svg>
                )}
            </div>
        </label>
    );
};

export default Checkbox;
